import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
  ScrollView,
} from 'react-native';
import { ms, s, vs } from '../../../../utils/responsive';
import { useNavigation } from '@react-navigation/native';
import { RootStackNavigationProp } from '../../../../types/navigation';
import { BottomNavBar } from '../../../../components/BottomNavBar';
import { tasksService } from '../../../../services/tasks';
import { mapTaskIdToKey } from '../../../../utils/taskKey';
import AsyncStorage from '@react-native-async-storage/async-storage';

import { createLogger } from '../../../../utils/logger';
const logger = createLogger('StreamingServiceProviderIntro');

export const StreamingServiceProviderIntroScreen: React.FC = () => {
  const navigation = useNavigation<RootStackNavigationProp>();

  const handleYes = () => {
    navigation.navigate('StreamingServiceProviderInput');
  };

  const handleNo = async () => {
    try {
      const taskKey = mapTaskIdToKey(92); // Cable TV or Streaming Service task
      await tasksService.completeTask(taskKey);
      await AsyncStorage.setItem('task_declined_92', 'true');
    } catch (e) {
      // Non-blocking; still return to checklist
      logger.debug('Error completing streaming task on decline:', e);
    }
    // Prefer nested navigate to trigger focus/refresh of the Property checklist
    (navigation as any).navigate('Property', { screen: 'PropertyChecklist', params: { refreshKey: Date.now() } });
  };


  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.mainContent}>
        <View style={styles.header}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => navigation.goBack()}
          >
            <Image
              source={require('../../../../assets/icons/back.png')}
              style={styles.backIcon}
            />
          </TouchableOpacity>
          <Image
            source={require('../../../../assets/logo.png')}
            style={styles.logo}
            resizeMode="contain"
          />
        </View>

        <ScrollView contentContainerStyle={styles.content}>
          <Text style={styles.title}>Do you have a streaming service or cable TV provider?</Text>

          <View style={styles.buttonContainer}>
            <TouchableOpacity
              style={[styles.button, styles.yesButton]}
              onPress={handleYes}
            >
              <Text style={[styles.buttonText, styles.yesText]}>Yes</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[styles.button, styles.noButton]}
              onPress={handleNo}
            >
              <Text style={[styles.buttonText, styles.noText]}>No</Text>
            </TouchableOpacity>
          </View>

          <Text style={styles.description}>
            Organizing your streaming service or cable TV provider as part of your end-of-life planning ensures your loved ones can manage or cancel the service. By keeping records like account numbers, passwords, contact details your family can quickly handle cancellations, transfers, or adjustments to your accounts.
          </Text>
        </ScrollView>
      </View>
      <BottomNavBar />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  mainContent: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ms(50),
    position: 'relative',
  },
  backButton: {
    position: 'absolute',
    left: ms(50),
    top: ms(15),
    padding: ms(5),
    zIndex: 1,
  },
  backIcon: {
    width: ms(32, 0.3),
    height: ms(32, 0.3),
    tintColor: '#333',
  },
  logo: {
    width: ms(125, 0.3),
    height: ms(125, 0.3),
  },
  content: {
    flexGrow: 1,
    padding: ms(20),
    alignItems: 'center',
  },
  title: {
    fontSize: ms(28, 0.3),
    fontWeight: '600',
    color: '#2C4364',
    marginBottom: ms(30),
    textAlign: 'center',
    paddingHorizontal: ms(20),
  },
  description: {
    fontSize: ms(18, 0.3),
    color: '#666666',
    textAlign: 'center',
    marginTop: ms(30),
    paddingHorizontal: ms(20),
    lineHeight: ms(25, 0.3),
  },
  buttonContainer: {
    width: '100%',
    paddingHorizontal: ms(20),
  },
  button: {
    width: '100%',
    borderRadius: ms(30),
    padding: ms(15),
    alignItems: 'center',
    marginBottom: ms(15),
  },
  yesButton: {
    backgroundColor: '#29BFC0',
  },
  noButton: {
    backgroundColor: '#FF9F64',
  },
  buttonText: {
    fontSize: ms(16, 0.3),
    fontWeight: '500',
  },
  yesText: {
    color: '#FFFFFF',
  },
  noText: {
    color: '#FFFFFF',
  },
});
